import React from 'react';
import { Row, Col, Image } from 'antd';
import AuthImg from '../../assets/img/main-banner.png';
import { Folio3AIIcon } from 'assets/icons';

const Thankyou = () => {
  return (
    <Row className='auth-container'>
      <Col span={10} className='auth-form-container'>
        <div>
          <a href='/' target='_blank' title='Chat Buddy Pro'>
            <Folio3AIIcon />
          </a>
          <h1> Thank You For Registering!</h1>
          <p className='thankyou-text'>Please verify your email address to start using ChatBuddy Pro. An email has been sent for your account activation.</p>
        </div>
      </Col>
      <Col span={14} className='auth-cover'>
        <div>
          <Image preview={false} src={AuthImg} />
        </div>
      </Col>
    </Row>
  );
};

export default Thankyou;
